import { Component, Input, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, Event as RouterEvent } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { LayoutStore } from '../layout.store';

import { RoutingService } from '../../routing.service';
import { SidebarRightService } from '../sidebar-right/sidebar-right.service';
import { HeaderService } from '../header/header.service';
import { FooterService } from '../footer/footer.service';

import { throttle } from '../../helpers';
export class ContentComponent implements OnInit {
public description: string;
public header: string;
public heightStyle: number;
public sidebarLeftHeight: number;
public sidebarRightHeight: number;
public windowInnerHeight: number
private layout: string;
private titleTag: string;
private navigationEnd: boolean;
private contentInnerElement: ElementRef;
/**
 * \@method constructor
 * @param {?} layoutStore
 * @param {?} routingService
 * @param {?} titleService
 * @param {?} elementRef
 * @param {?} changeDetectorRef
 * @param {?} sidebarRightService
 * @param {?} headerService
 * @param {?} footerService
 * @param {?} router
 */
constructor(
private layoutStore: LayoutStore,
private routingService: RoutingService,
private titleService: Title,
private elementRef: ElementRef,
private changeDetectorRef: ChangeDetectorRef,
private sidebarRightService: SidebarRightService,
private headerService: HeaderService,
private footerService: FooterService,
private router: Router
  ) {}
/**
 * \@method ngOnInit
 * @return {?}
 */
ngOnInit() {
    this.titleTag = this.titleService.getTitle();

    this.routingService.onChange.subscribe((value: any) => {
      if(value && value[value.length - 1]) {
        this.titleService.setTitle(this.getTitle(value[value.length - 1].data['title']));
        this.header = value[value.length - 1].data['title'];
        this.description = value[value.length - 1].data['description'];
      }
      this.changeDetectorRef.markForCheck();
    });

    this.router.events.subscribe((routeEvent: RouterEvent) => {
      if(routeEvent instanceof NavigationStart) {
        this.navigationEnd = false;
      }
      if(routeEvent instanceof NavigationEnd) {
        this.navigationEnd = true;
        this.setContentMinHeight();
      }
    });

    this.layoutStore.sidebarLeftElementHeight.subscribe((value: number) => {
      this.sidebarLeftHeight = value;
      this.setContentMinHeight();
    });

    this.layoutStore.layout.subscribe((value: string) => {
      this.layout = value;
      this.setContentMinHeight();
    });

    this.layoutStore.windowInnerHeight.subscribe((value: number) => {
      this.windowInnerHeight = value;
      this.setContentMinHeight();
    });
    this.heightStyle = this.windowInnerHeight;
  }
/**
 * @return {?}
 */
public get scrollHeight(): number {
    return this.contentInnerElement.nativeElement.scrollHeight;
  }
/**
 * [getTitle description]
 * \@method getTitle
 * @param {?} title
 * @return {?}
 */
private getTitle(title: string): string {
    return title ? `${title} - ${this.titleTag}` : this.titleTag;
  }
/**
 * [setMinHeight description]
 * \@method setMinHeight
 * @return {?}
 */
private setContentMinHeight(): void {
    if(this.navigationEnd) {
      let /** @type {?} */ heightStyle, /** @type {?} */
          headerFooterOffsetHeight = this.headerService.offsetHeight + this.footerService.offsetHeight;

      if(this.layout === 'fixed') {
        heightStyle = this.windowInnerHeight - this.footerService.offsetHeight;
      } else {
        let /** @type {?} */ sidebarRight = this.sidebarRightService.scrollHeight ? this.sidebarRightService.scrollHeight - this.headerService.offsetHeight: 0;
        heightStyle = Math.max(this.windowInnerHeight - headerFooterOffsetHeight, this.sidebarLeftHeight - this.headerService.offsetHeight, sidebarRight);
      }

      if(heightStyle && heightStyle !== this.heightStyle) {
        if(this.scrollHeight > heightStyle) {
          heightStyle = null;
        }
        this.heightStyle = heightStyle;
        this.changeDetectorRef.detectChanges();
      }
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-layout-content',
  template: `
    <div class="content-wrapper" [style.min-height.px]="heightStyle">
      <div #contentInnerElement class="content-inner">
        <ng-content select="[mk-layout-content-before-header]"></ng-content>
        <section *ngIf="header || description" class="content-header">
          <h1>
            {{header}}
            <small *ngIf="description">{{description}}</small>
          </h1>
          <mk-breadcrumbs></mk-breadcrumbs>
        </section>
        <ng-content select="[mk-layout-content-after-header]"></ng-content>
        <section class="content">
          <ng-content></ng-content>
        </section>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }

    .content-wrapper {
         position: relative;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: LayoutStore, },
{type: RoutingService, },
{type: Title, },
{type: ElementRef, },
{type: ChangeDetectorRef, },
{type: SidebarRightService, },
{type: HeaderService, },
{type: FooterService, },
{type: Router, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'contentInnerElement': [{ type: ViewChild, args: ['contentInnerElement', ] },],
};
}

function ContentComponent_tsickle_Closure_declarations() {
/** @type {?} */
ContentComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ContentComponent.ctorParameters;
/** @type {?} */
ContentComponent.propDecorators;
/** @type {?} */
ContentComponent.prototype.description;
/** @type {?} */
ContentComponent.prototype.header;
/** @type {?} */
ContentComponent.prototype.heightStyle;
/** @type {?} */
ContentComponent.prototype.sidebarLeftHeight;
/** @type {?} */
ContentComponent.prototype.sidebarRightHeight;
/** @type {?} */
ContentComponent.prototype.windowInnerHeight;
/** @type {?} */
ContentComponent.prototype.layout;
/** @type {?} */
ContentComponent.prototype.titleTag;
/** @type {?} */
ContentComponent.prototype.navigationEnd;
/** @type {?} */
ContentComponent.prototype.contentInnerElement;
/** @type {?} */
ContentComponent.prototype.layoutStore;
/** @type {?} */
ContentComponent.prototype.routingService;
/** @type {?} */
ContentComponent.prototype.titleService;
/** @type {?} */
ContentComponent.prototype.elementRef;
/** @type {?} */
ContentComponent.prototype.changeDetectorRef;
/** @type {?} */
ContentComponent.prototype.sidebarRightService;
/** @type {?} */
ContentComponent.prototype.headerService;
/** @type {?} */
ContentComponent.prototype.footerService;
/** @type {?} */
ContentComponent.prototype.router;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
